import Vue from "vue";
import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ISiteCreateRequest,
  ISiteListRequest,
  ISiteUpdateRequest,
  SiteState,
  ISite
} from "@/types/site";
import { IAmountByCategory } from "@/types/amount_by_category";

import axios from "axios";

export const actions: ActionTree<SiteState, RootState> = {
  async getList({ commit }, params: ISiteListRequest) {
    try {
      const response = await axios.get<IPagination<ISite[]>>("/site", {
        params
      });

      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async get({ commit }, siteId: number) {
    try {
      const response = await axios.get<ISite>(`/site/${siteId}`);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async amount({ commit }, site_id: number) {
    try {
      const response = await axios.get<number>(`/site/${site_id}/amount`);

      commit("amount", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminUpdate(
    { commit },
    data: { site_id: number; params: ISiteUpdateRequest }
  ) {
    try {
      const response = await axios.patch<ISite>(
        `/admin/site/${data.site_id}`,
        data.params
      );

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("更新完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "更新失敗:入力した値を確認してください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      return false;
    }
  },
  async adminCreate({ commit }, params: ISiteCreateRequest) {
    try {
      const response = await axios.post<ISite>(`/admin/site`, params);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("作成完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "作成失敗:入力した値を確認してください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      return false;
    }
  },
  async adminGet({ commit }, site_id: number) {
    try {
      const response = await axios.get<ISite>(`/admin/site/${site_id}`);
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminGetList({ commit }, params: ISiteListRequest) {
    try {
      const response = await axios.get<IPagination<ISite[]>>("/admin/site", {
        params
      });
      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminAmount({ commit }, site_id: number) {
    try {
      const response = await axios.get<number>(`/admin/site/${site_id}/amount`);

      commit("amount", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminAmountByCategory({ commit }, site_id: number) {
    try {
      const response = await axios.get<IAmountByCategory>(
        `/admin/site/${site_id}/amount-by-category`
      );
      commit("byCategory", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async amountByCategory({ commit }, site_id: number) {
    try {
      const response = await axios.get<IAmountByCategory>(
        `/site/${site_id}/amount-by-category`
      );
      commit("byCategory", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },

  async customerGet({ commit }, site_id: number) {
    try {
      const response = await axios.get<ISite>(`/customer/site/${site_id}`);
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async subcontractorGet({ commit }, site_id: number) {
    try {
      const response = await axios.get<ISite>(`/subcontractor/site/${site_id}`);
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },

  async updateCompletion({ commit }, site_id: number) {
    try {
      const response = await axios.patch<ISite>(
        `/site/${site_id}/updateCompletion`
      );
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("ステータス更新完了", "success", {
        timeout: 3000,
        important: true
      });
    } catch (error) {
      Vue.prototype.$flashStorage.flash(
        "更新失敗：時間をおいてお試しください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async updateInputCompleted({ commit }, site_id: number) {
    try {
      const response = await axios.patch<ISite>(
        `/site/${site_id}/updateInputCompleted`
      );
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("ステータス更新完了", "success", {
        timeout: 3000,
        important: true
      });
    } catch (error) {
      Vue.prototype.$flashStorage.flash(
        "更新失敗：時間をおいてお試しください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async updateBilling({ commit }, site_id: number) {
    try {
      const response = await axios.patch<ISite>(
        `/admin/site/${site_id}/updateBilling`
      );
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("ステータス更新完了", "success", {
        timeout: 3000,
        important: true
      });
    } catch (error) {
      Vue.prototype.$flashStorage.flash(
        "更新失敗：時間をおいてお試しください",
        "error",
        {
          timeout: 3000,
          important: true
        }
      );
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  }
};

export default actions;
